import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

export default function AboutPrincipal() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/asmb2.jpg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            About Principal
          </div>
        </div>

        <div className="aboutabout" style={{ marginTop: "50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Message From Principal
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                At the SLV International School ,we believe in supporting every
                individual to achieve his or her dreams, no matter how big they
                may be. Our students are ambitious, inquisitive and hardworking,
                ever embracing challenges and striving for their best. We make
                out that all children have diverse abilities and talents, and we
                are devoted to helping them discover and develop these in a
                nurturing environment. Inclusion is an important part of life at
                the SLV International School.
                <br />
                <br />
                As Principal of SLV International School and as a parent myself,
                I believe in raising children to be polite, respectful, and
                responsible citizens, able to make a positive contribution to
                society. Of equal importance is children’s social and emotional
                development, enabling them to become confident, assured, and
                happy. I believe in building a community based on traditional
                values and mutual respect, where students take pride in
                themselves, their work, and their school, contributing fully on
                a daily basis to the benefit of all.
                <br />
                <br /> If you are considering SLV International School for your
                child, I warmly encourage you to visit us and experience
                firsthand our unique environment and culture. We welcome
                visitors throughout the year, so please don’t hesitate to get in
                touch and make an appointment.
                <br />
                <br />
                <b> Joby Varghese , Principal </b> <br />
                MA (Eng), MA (Soc), BEd (Eng), MEd, BEd (Spl. Edu.)
              </div>
            </Grid>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={require("../img/princi.jpg")}
              />
            </Grid>
          </Grid>
          <div
            style={{
              marginTop: "50px",
              textAlign: "justify",
              fontSize: state.auth.isMobile ? "18px" : "22px",
            }}
          >
            We prepare our students to achieve excellent examination results
            and, at the same time, develop into well-rounded young adults who
            have the skills, attributes, and moral fibre to lead successful
            lives. We believe that an education should stretch young people
            academically and also develop them socially, all the while
            supporting them emotionally and ensuring their health, safety, and
            happiness.
            <br />
            <br />
            We provide a quality academic education based on the rigorous
            National Curriculum of our country with an international flavour.
            Our curriculum is designed to be broad and balanced to keep
            opportunities open while giving excellent preparation for further
            study. Being one of the leading schools, we pride ourselves on
            delivering a values-driven, high-standard education, expressed
            through four core values: leading through innovation, pursuing
            excellence, growing by learning, and global citizenship. These are
            woven into each of our academic and extracurricular activities and
            form the basis of everything we do. Accordingly, through our formal
            and informal curriculum, we encourage creative and critical thinking
            alongside stimulating and meaningful experiences. Integrated into
            our learning is the development of a range of key skills,
            attributes, and attitudes that we know will serve our students well
            in their later lives. The development of leadership skills is an
            important part of our curriculum, and all students have the chance
            to be involved in school leadership activities. We firmly believe in
            developing our students into global citizens who can excel on the
            world stage. We aim to develop a tolerant school community,
            reflecting the heritage of our students and recognizing that we all
            come from different backgrounds.
            <br />
            <br />{" "}
          </div>
        </div>

        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
